module.exports = __webpack_public_path__ + "img/empty.744e442.webp";